var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticStyle:{"min-height":"587px"},attrs:{"headers":_vm.headers,"items":_vm.log,"multi-sort":""},scopedSlots:_vm._u([{key:"item.inOut",fn:function(ref){
var item = ref.item;
return [(item.inOut === false)?_c('v-icon',{staticClass:"ml-1",attrs:{"color":"danger"}},[_vm._v("mdi-phone-outgoing")]):_c('v-icon',{staticClass:"ml-1",attrs:{"color":"green"}},[_vm._v("mdi-phone-incoming")])]}},{key:"item.fromTo",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"mr-0 mb-0"},[_vm._v(_vm._s(item.fromTo))])]}},{key:"item.dateTime",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"mr-md-4 mr-lg-4 mr-sm-0 mr-xs-0 mb-0"},[_vm._v(_vm._s(item.dateTime))])]}},{key:"item.duration",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"mr-0 mb-0"},[_vm._v(_vm._s(item.duration))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }